import { Component } from '@angular/core';
import { UserDetails } from '@bn/api-interfaces';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { LazyLoadDirective } from '@bn/web-ui';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'bn-email-not-verified',
  templateUrl: './email-not-verified.page.html',
  styleUrls: ['email-not-verified.page.scss'],
  imports: [ButtonComponent, LazyLoadDirective, NgStyle],
})
export class EmailNotVerifiedPage extends AbstractLazyDirective {
  public isLoading = false;
  public userFirstName = '';

  constructor() {
    super();

    this.userDetailsService.getUserDetails().subscribe({
      next: (userDetails: UserDetails | null) => (this.userFirstName = userDetails?.FirstName || ''),
    });
  }

  public onResendClick(): void {
    if (this.isLoading) return;

    this.isLoading = true;

    this.subscriptions.add(
      this.userDetailsService.resendConfirmationEmail().subscribe({
        next: () => (this.isLoading = false),
        error: () => (this.isLoading = false),
      }),
    );
  }
}
